import React, { FC, useState } from 'react';
import { Radio, Space, Form, Row, Col, notification, Modal } from 'antd';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { PrimaryButtonX } from '../../../Components/Button3D';
import { Input3D } from '../../../Components/Input3D';
import { ExpertText, SmallText } from '../../../Components/Text3D';
import { useStoreActions, useStoreState } from '../../../myStore';

const MainWrapper = styled(Row)`

/* &:before{
      content: '';
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 20px solid white;
      margin-left: 35rem;
    } */
`
const Content = styled(Col)`
    background-color: white;
    /* padding-bottom: 2rem; */
    width: 100%;
    font-family: "Rogan", -apple-system, BlinkMacSystemFont, sans-serif;
`
const TopSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2rem 0 .6rem .5rem;
    margin: 0 2rem;
    border-bottom: 1px solid #D8D8D8;
`;
const ContentWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2rem;
`;
const ContentSection = styled.div`
`
const ContentBox = styled.div`
    border: 1px solid #D8D8D8;
`
const ContentDiv = styled.div`
    padding: 2rem;
`
const RadioDiv = styled.div`
    padding: .8rem 0 0 1.5rem;
`
const Span = styled.span`
    font-size: 16px;
`
interface Props {
    handleClick(data: any): any
    collectedDatas: any;
}

const UploadNewPublish: FC<Props> = ({ handleClick, collectedDatas }) => {

    const history = useHistory();
    const [value, setValue] = useState();
    const [price, setPrice] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const designFormData = useStoreState((state) => state.design.designFormData);
    const setDesignFormData = useStoreActions((actions) => actions.design.setDesignFormData);


    const onChange = (e: any) => {
        setValue(e.target.value);
    };

    const handleTypeClick = (e: any) => {
        if (!value) {
            notification.error({
                message: "Error",
                description: "pleace choose the plan"
            })
        } else {
            if (value === "PAID") {
                if (!price) {
                    notification.error({
                        message: "Error",
                        description: "choose the best price for your design"
                    })
                } else {
                    setDesignFormData({ ...designFormData, marketPlaceType: value, designPrice: price })
                    history.push("/dashboard/design/info")
                }
            } else {
                setDesignFormData({ ...designFormData, marketPlaceType: value })
                history.push("/dashboard/design/thumbnail")
            }
        }
    };
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            <MainWrapper>
                <Content>
                    <TopSection>
                        <ExpertText dark>Dashboard / <a href="s">Upload New Design</a></ExpertText>
                    </TopSection>
                    <ContentWrapper>
                        <ContentSection>
                            <ContentBox>
                                <ContentDiv>
                                    <SmallText size line><a href="q">Upload this to marketplace for</a></SmallText>
                                    <Form.Item >
                                        <RadioDiv>
                                            <Radio.Group onChange={onChange} value={value}>
                                                <Space direction="vertical">
                                                    <Radio value='FREE'><Span>Free Use</Span></Radio>
                                                    <Radio value='PAID' onClick={showModal}><Span>Paid on download</Span></Radio>
                                                    <Radio value='PRIVATE'><Span>Private</Span></Radio>
                                                </Space>
                                            </Radio.Group>
                                        </RadioDiv>
                                    </Form.Item>
                                </ContentDiv>
                            </ContentBox>
                            <Modal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                                <p>Enter best price for your design <strong>{"(In USD)"}</strong></p>
                                <Input3D type='number' onChange={(e) => setPrice(Number(e.target.value))} />
                            </Modal>
                            <div style={{ display: 'flex', flexFlow: 'row', justifyContent: 'flex-end' }}>
                                <PrimaryButtonX type='primary' style={{ marginTop: '2rem' }} onClick={handleTypeClick} >next</PrimaryButtonX>
                            </div>
                        </ContentSection>
                    </ContentWrapper>
                </Content>
            </MainWrapper>
        </>
    )
}
export default UploadNewPublish;